import { Pencil, Save, X } from "lucide-react";
import type { FC } from "react";

import { m } from "@recobra/i18n/messages";
import { Button } from "@recobra/ui/button";
import { ButtonGroup } from "@recobra/ui/button-group";

import type { EditableTaskField, TaskMetadataEditor } from "./useTaskMetadataEditor";

export const TaskMetadataFieldActions: FC<{
  field: EditableTaskField;
  editor: TaskMetadataEditor;
}> = ({ field, editor }) => {
  if (!editor.canEditField(field)) return null;

  return editor.editing === field ? (
    <ButtonGroup>
      <Button
        type="button"
        variant="ghost"
        size="icon-xs"
        disabled={editor.isPending}
        aria-label={m.task_save()}
        onClick={editor.save}
      >
        <Save />
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon-xs"
        disabled={editor.isPending}
        aria-label={m.task_cancel()}
        onClick={editor.cancelEditing}
      >
        <X />
      </Button>
    </ButtonGroup>
  ) : (
    <Button
      type="button"
      variant="ghost"
      size="icon-xs"
      disabled={editor.isPending}
      aria-label={m.task_edit_title()}
      onClick={() => editor.startEditing(field)}
    >
      <Pencil />
    </Button>
  );
};
